import { render, staticRenderFns } from "./CollapseIcon.vue?vue&type=template&id=9bec6b4a&"
import script from "./CollapseIcon.vue?vue&type=script&lang=js&"
export * from "./CollapseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CollapseIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports